import styled from "styled-components";
import { getRunStatusStyle } from "./pipelineHealthUtils";

export const FiltersRow = styled.div`
	display: flex;
	align-items: center;
	gap: 1.2rem;
	flex-wrap: wrap;
`;

export const GeneratedAt = styled.span`
	margin-left: auto;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.colors.textSecondary};
	white-space: nowrap;
`;

export const StateMessage = styled.div`
	padding: 3.2rem 1.6rem;
	text-align: center;
	color: ${({ theme }) => theme.colors.textSecondary};
	font-size: 1.4rem;
`;

export const Table = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 50vh;
	overflow-y: auto;
	border: 0.1rem solid ${({ theme }) => theme.colors.lightItemBorder};
	border-radius: 0.4rem;
`;

export const TableHeaderRow = styled.div`
	display: grid;
	grid-template-columns: 2.4rem 1fr 1.8fr 0.9fr 1.7fr 1.7fr 0.8fr;
	gap: 0.8rem;
	padding: 0.8rem 1.2rem;
	font-size: 1.1rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.02rem;
	white-space: nowrap;
	color: ${({ theme }) => theme.colors.textSecondary};
	background: ${({ theme }) => theme.colors.tableThBackground};
	position: sticky;
	top: 0;
`;

export const RowSummary = styled.button`
	display: grid;
	grid-template-columns: 2.4rem 1fr 1.8fr 0.9fr 1.7fr 1.7fr 0.8fr;
	gap: 0.8rem;
	align-items: center;
	width: 100%;
	padding: 1rem 1.2rem;
	font-size: 1.25rem;
	white-space: nowrap;
	color: ${({ theme }) => theme.colors.textPrimary};
	background: ${({ theme }) => theme.colors.componentBackground};
	border: none;
	border-bottom: 0.1rem solid ${({ theme }) => theme.colors.lightItemBorder};
	text-align: left;
	cursor: pointer;

	&:hover {
		background: ${({ theme }) => theme.colors.hoverColor};
	}
`;

export const ExpandToggle = styled.span<{ $expanded: boolean }>`
	display: inline-flex;
	transform: rotate(${({ $expanded }) => ($expanded ? "90deg" : "0deg")});
	transition: transform 0.15s ease-in-out;
	color: ${({ theme }) => theme.colors.textSecondary};
`;

export const StatusBadge = styled.span<{ $stateKey: string }>`
	display: inline-flex;
	align-items: center;
	justify-self: start;
	width: fit-content;
	padding: 0 0.6rem;
	border-radius: 0.4rem;
	font-size: 1.1rem;
	font-weight: 600;
	line-height: 1.8rem;
	white-space: nowrap;
	background: ${({ $stateKey }) => getRunStatusStyle($stateKey).background};
	border: 0.1rem solid ${({ $stateKey }) => getRunStatusStyle($stateKey).border};
	color: ${({ $stateKey }) => getRunStatusStyle($stateKey).color};
`;

export const RunsDetail = styled.div`
	padding: 0.8rem 1.2rem 1.2rem 4.4rem;
	background: ${({ theme }) => theme.colors.backgroundPrimary};
	border-bottom: 0.1rem solid ${({ theme }) => theme.colors.lightItemBorder};
`;

export const RunsHeaderRow = styled.div`
	display: grid;
	grid-template-columns: 1.7fr 1.7fr 0.8fr 0.7fr 2fr;
	gap: 0.8rem;
	padding: 0.4rem 0;
	font-size: 1.05rem;
	font-weight: 600;
	white-space: nowrap;
	color: ${({ theme }) => theme.colors.textSecondary};
`;

export const RunRow = styled.div`
	display: grid;
	grid-template-columns: 1.7fr 1.7fr 0.8fr 0.7fr 2fr;
	gap: 0.8rem;
	align-items: center;
	padding: 0.5rem 0;
	font-size: 1.15rem;
	white-space: nowrap;
	border-top: 0.1rem solid ${({ theme }) => theme.colors.lightItemBorder};
`;

export const PerMarketplaceList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	font-size: 1.05rem;
	white-space: normal;
	color: ${({ theme }) => theme.colors.textSecondary};
`;

export const TruncationNote = styled.div`
	padding: 0.6rem 0 0;
	font-size: 1.05rem;
	color: ${({ theme }) => theme.colors.textSecondary};
`;
